import React, { useEffect, useState } from 'react';
import HeaderBack from '../../components/HeaderBack/HeaderBack';
import styles from './users-activity-page.module.css';
import { getDocsOrderByBd } from '../../firebase';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import CounterList from '../../components/CounterList/CounterList';

export default function UsersActivityPage() {
  const [loaderPage, setLoaderPage] = useState(false);
  const [webCounterList, setWebCounterList] = useState([]);
  const [restartUseEffect, setRestartUseEffect] = useState(0);

  // Потрібно коли видаляєм активність перерендерити сторінку
  const restartPage = () => {
    setWebCounterList([]);
    setRestartUseEffect(new Date().getTime());
  };

  useEffect(() => {
    const getData = async () => {
      setLoaderPage(true);
      const docs = await getDocsOrderByBd('loginWebCounter', 'timeViewMilliseconds', 'desc');
      if (docs) {
        setWebCounterList(docs);
      }
      setLoaderPage(false);
    };
    getData();
  }, [restartUseEffect]);

  return (
    <>
      <HeaderBack />
      <div className={styles.page_wrapper}>{CounterList(webCounterList, restartPage)}</div>
      {loaderPage && <LoaderPage />}
    </>
  );
}
